export const inputCls = `px-3 py-2.5 rounded-xl text-sm text-blue-900
  border border-blue-200 bg-white placeholder-blue-300
  focus:outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-100
  hover:border-blue-400 transition-all duration-200
  disabled:opacity-50 disabled:cursor-not-allowed`;